import React, { useState, useEffect } from 'react';
export function AIStorefrontVoice2() {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isMobile = windowWidth <= 767;
  const cards = [{
    img: "https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/chat-mode-asset-kee32afywd.png",
    title: "Chat mode",
    desc: "The AI Shopping Assistant, added to your store as it is today. No rebuild. No migration. The fastest way to bring AI to every shopper.",
    btnLabel: "Start with chat mode"
  }, {
    img: "https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/full-mode-asset-p11vx6se8rd.png",
    title: "Full immersive AI experience",
    desc: "All features working as one. The Assistant gets smarter. Personalization gets deeper. Agents get sharper. Your whole store, end to end.",
    btnLabel: "Get a full AI storefront"
  }];
  return <section style={{
    backgroundColor: '#FCFAF6',
    paddingTop: 'clamp(60px, 8vw, 120px)',
    paddingBottom: 'clamp(60px, 8vw, 120px)'
  }}>
      <div className="section-content" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      padding: '0 24px'
    }}>

        {/* Headline */}
        <h2 style={{
        fontSize: 'clamp(52px, 7vw, 92px)',
        lineHeight: 1.05,
        color: '#091717',
        margin: '0 0 44px 0',
        fontWeight: 400
      }}>
          <span style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>Start small. Or </span><em style={{
          fontFamily: 'Instrument Serif, serif',
          fontStyle: 'italic',
          fontWeight: 400,
          letterSpacing: '-0.02em'
        }}>go all in.</em>
        </h2>

        {/* 2-column card grid */}
        <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        gap: isMobile ? '32px' : '20px'
      }}>
          {cards.map(card => <div key={card.title} style={{
          overflow: 'hidden'
        }}>
              <img src={card.img} alt={card.title} style={{
            width: '100%',
            display: 'block',
            objectFit: 'cover'
          }} />
              <div style={{
            paddingTop: isMobile ? '20px' : '24px'
          }}>
                <p style={{
              fontSize: '20px',
              fontWeight: 500,
              letterSpacing: '-0.02em',
              color: '#091717',
              marginBottom: '8px',
              lineHeight: 1.3,
              fontFamily: 'Instrument Sans, sans-serif'
            }}>
                  {card.title}
                </p>
                <p style={{
              fontSize: '16px',
              fontWeight: 400,
              color: '#091717',
              lineHeight: 1.5,
              fontFamily: 'Instrument Sans, sans-serif',
              opacity: 0.7,
              marginBottom: '24px'
            }}>
                  {card.desc}
                </p>
                <a href="/book-a-demo" style={{
              display: 'inline-block',
              backgroundColor: 'transparent',
              color: '#091717',
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              borderRadius: '999px',
              padding: '12px 24px',
              textDecoration: 'none',
              border: '1px solid #091717',
              transition: 'opacity 0.2s ease'
            }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.5'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-aisf-voice2-demo">
                  {card.btnLabel}
                </a>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}